// Footer columns are native <details>: always open from the md breakpoint, collapsible accordions below it.
class SFooterAccordion extends HTMLElement {
  #query;
  #onChange;

  connectedCallback() {
    this.#query = window.matchMedia('(min-width: 768px)');
    this.#onChange = () => {
      const desktop = this.#query.matches;
      this.querySelectorAll('details').forEach((details) => {
        details.open = desktop;
      });
    };
    this.#query.addEventListener('change', this.#onChange);
    this.#onChange();
  }

  disconnectedCallback() {
    this.#query?.removeEventListener('change', this.#onChange);
  }
}

if (!customElements.get('s-footer-accordion')) customElements.define('s-footer-accordion', SFooterAccordion);
